import React, {FC, useEffect, useState} from "react"
import onboardingService, {OnboardingStep} from "@irati/onboarding/services/onboarding"
import authentication from "@irati/auth"
import {FormattedMessage} from "@irati/utils/lang"
import Slider from "@irati/ui/src/Slider"
import {H2} from "@irati/ui/src/Typography"
import {TextButton} from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {Col, Row} from "@irati/ui/src/Layout"
import {User} from "@irati/types"
import {includes} from "lodash"
import OnboardingCard from "./OnboardingCard"
import {RewardInformationSection, sliderSettings, adminSteps, maangerSteps} from "./styled"

interface Props {
  user: User
}

const OnboardingSection: FC<Props> = ({user}) => {
  const [showOnboarding, setShowOnboarding] = useState(true)
  const isAdmin = authentication.isGlobalAdmin()

  useEffect(() => {
    onboardingService.get(user.uuid!).then((userOnboarding) => {
      const onboardingStepStatus = !(userOnboarding.userProgress || []).find(({step}) =>
        includes(
          [OnboardingStep.HAS_VIEWED_FLEXI_REWARDS_MANAGER_ONBOARDING, OnboardingStep.HAS_VIEWED_FLEXI_REWARDS_ADMIN_ONBOARDING],
          step
        )
      )
      setShowOnboarding(onboardingStepStatus)
    })
  }, [user])

  const completeStep = () => {
    onboardingService.completeStep(
      user,
      adminSteps ? OnboardingStep.HAS_VIEWED_FLEXI_REWARDS_ADMIN_ONBOARDING : OnboardingStep.HAS_VIEWED_FLEXI_REWARDS_MANAGER_ONBOARDING
    )
    setShowOnboarding(false)
  }

  if (!showOnboarding) return null

  return (
    <>
      <H2 marginBottom={2}>
        <FormattedMessage id="wallet.reward.onboarding.section.title" />
      </H2>
      <RewardInformationSection>
        <Slider slidesToShow={3} settings={sliderSettings}>
          <OnboardingCard steps={isAdmin ? adminSteps.stepOne : maangerSteps.stepOne} completeStep={completeStep} />
          <OnboardingCard steps={isAdmin ? adminSteps.stepTwo : maangerSteps.stepTwo} completeStep={completeStep} />
          <OnboardingCard steps={isAdmin ? adminSteps.stepThree : maangerSteps.stepThree} completeStep={completeStep} />
        </Slider>

        <Row>
          <Col xsHidden smHidden md={12}>
            <Flex justifyContent="flex-end" paddingBottom={4} paddingRight={4}>
              <TextButton onClick={completeStep}>
                <FormattedMessage id="wallet.reward.onboarding.section.doNotShowAgain.button" />
              </TextButton>
            </Flex>
          </Col>
        </Row>
      </RewardInformationSection>
    </>
  )
}

export default OnboardingSection
